import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { BLANK_IMAGE_URL } from "@configs";
import { IMembershipTier, IReward } from "@interfaces";
// import { IconStarSmall } from "@components";
import { selectAuth, selectMerchant } from "@redux";
import { IconPoint } from "../icon/Point";

interface IProps {
    data: IReward;
    handleClick: (value: IReward, check: boolean) => void;
    lastItem: boolean;
}

export const RewardItem = (props: IProps) => {
    //hook
    const { t } = useTranslation();
    //page props
    const { data, lastItem, handleClick } = props;
    //redux state
    const { memberShipTiers } = useSelector(selectMerchant);
    const { userInfo } = useSelector(selectAuth);
    //page variable
    const currentMemberShiptTier = userInfo?.memberTier;

    const checkIfNotIncludeRank = () => {
        const arr = getArrayMemberTier();
        if (arr.length) {
            const index = arr.findIndex((item) => item._id === currentMemberShiptTier?._id);
            if (index === -1) {
                return arr.reduce(
                    (pre, item, index) =>
                        index < arr.length - 1
                            ? `${pre} ${item.membershipName}, `
                            : `${pre} ${item.membershipName}`,
                    ""
                );
            } else return false;
        } else return false;
    };

    const getArrayMemberTier = () => {
        const arr: IMembershipTier[] = [];
        memberShipTiers?.forEach((memberTier) => {
            if (data.levelIds?.includes(memberTier._id)) arr.push(memberTier);
        });
        return arr;
    };

    const getDisplayPoint = () => {
        if (data.isPointByTier) {
            const myTierId = currentMemberShiptTier?.tierId || currentMemberShiptTier?._id;
            const myTier = data.tierPointList?.find((tier: any) => tier.tierId === myTierId);
            return <span className="tier-point">{myTier ? myTier.point : "-"}</span>;
        } else {
            return <span className="tier-point">{data.point}</span>;
        }
    };

    return (
        <StyledContainer slot="container-end" lastItem={lastItem}>
            <div className="item-layout">
                <div className="image">
                    <span>
                        <img
                            src={data.imageUrl[0] || BLANK_IMAGE_URL}
                            onClick={() => handleClick(data, Boolean(checkIfNotIncludeRank()))}
                        />
                    </span>

                    {checkIfNotIncludeRank() ? (
                        <div className="silver_member">
                            <div className="line"></div>
                            <div className="text">
                                {t("page.MEMBER", { text: checkIfNotIncludeRank() })}
                            </div>

                            <div className="line"></div>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
                <div
                    className="desc"
                    onClick={() => handleClick(data, Boolean(checkIfNotIncludeRank()))}
                >
                    <p className="text-sec-sub-header">{data.name}</p>
                    <div className="start">
                        <IconPoint />
                        {getDisplayPoint()}
                    </div>
                </div>
            </div>
        </StyledContainer>
    );
};

const StyledContainer = styled.div<{ lastItem: boolean }>`
    // padding-right: ${(props) => (props.lastItem ? "12px" : "unset")};
    width: 100%;
    height: 100%;
    /* .text-sec-sub-header {
        color: ${(p) => p.theme.colors.color} !important;
    } */

    .item-layout {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
        overflow: hidden;
        background-color: inherit;
        color: inherit;
        filter: drop-shadow(0px 0px 8px rgba(175, 175, 175, 0.16));
        margin-bottom: 15px;
    }
    .starSmall {
        position: absolute;
        top: 12px;
        left: 12px;
        padding: 4px 6px;
        background-color: inherit;
        z-index: 10;
        border-radius: 16px;
        span {
            display: inline-block;
            margin: 0 6px;
            color: #000000;

            font-style: normal;
            font-weight: 600;
            font-size: 14px;
        }
    }
    .image {
        width: 100%;
        position: relative;
        overflow: hidden;
        border-radius: 14px;
        padding-top: 100%;
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                object-fit: cover;
                height: 100%;
                cursor: pointer;
                &:hover {
                    transform: scale(1.05);
                    transition: 0.6s;
                }
            }
        }
        .silver_member {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
            display: flex;
            justify-content: center;
            align-items: center;

            cursor: none;
            .line {
                width: 23px;
                height: 1px;
                background-color: #fff;
            }
            .text {
                padding: 0 12px;
                flex: 1;
                color: #fff;
                text-transform: uppercase;
                max-width: 70%;
                word-break: break-all;

                font-style: normal;
                font-weight: normal;
                font-size: 10px;
                text-align: center;
            }
        }
    }

    .desc {
        flex: 1;
        position: relative;
        // background: ${(p) => p.theme.colors.card};
        background-color: transparent;
        p {
            margin-bottom: 16px;
            line-height: 1.8em;
            color: inherit;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 10px 8px 0 8px;
            cursor: pointer;
            font-style: normal;
            white-space: pre-wrap;
            height: auto;
            word-break: break-word;
            margin-bottom: 5px;
        }
        .start {
            position: relative;
            align-items: center;
            padding: 0 6px 0;
            z-index: 10;
            span {
                display: inline-block;
                margin-left: 4px;
                font-style: normal;
                font-weight: 600;
                font-size: 14px;
                color: #000000;
                top: 1px;
                position: relative;
            }
        }
    }

    .tier-point-list {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
        .tier-point-item {
            display: flex;
            align-items: center;
            font-size: 13px;
            margin-bottom: 2px;
        }
        .tier-name {
            font-weight: 500;
            margin-right: 4px;
        }
        .tier-point {
            font-weight: 600;
            color: #000;
            margin-left: 6px;
            font-size: 14px;
        }
    }
`;
